/**
 * Permission function names — must match core.functions.name exactly (1:1 with sidebar menus).
 * Do not reuse one code for multiple menus.
 */
export const FC = {
  // Home (Document Dashboard). Missing rights keep it visible until the Home function is seeded.
  HOME: 'Home',

  // Financial Operations
  PAYMENT_INTELLIGENCE: 'Payment Intelligence',
  CASH_RECONCILIATION: 'Cash Reconciliation',
  MERCHANT_DATA_HUB: 'Merchant Data Hub',
  CHARGEBACK_MANAGEMENT: 'Chargeback Management',

  // Operational Automation
  WORKFORCE_OPTIMIZATION: 'Workforce Optimization',
  PMS_RECONCILIATION: 'PMS Reconciliation & Performance',

  // Data Extraction
  DOCUMENT_VALIDATION: 'Document Validation',
  ETVL_ENGINE: 'ETVL Engine',
  GL_SYNC: 'GL Sync',

  // Configurations
  TENANT_WORKFLOW: 'Tenant Workflow',
  USERS: 'Users',
  MASTER_DATA: 'Master Data',
  PROPERTY: 'Property',
  PROPERTY_GROUP: 'Property Group',
  VENDOR_MASTER: 'Vendor Master',
  GL_ACCOUNT_MASTER: 'GL Account Master',
  BANK_MASTER: 'Bank Master',
  BUDGET_REVENUE_CODES: 'Budget / Revenue Codes',
  CONTRACT_MASTER: 'Contract Master',
  APP_CONFIG: 'App Config',
  NOTIFICATION_CONFIGURATION: 'Notification Configuration',
  REFERENCE_TEMPLATES: 'Reference Templates',
  DEPARTMENT_MASTER: 'Department Master',
  GLOBAL_EMPLOYEE: 'Global Employee',

  // Harmonate-only
  TENANT: 'Tenant',
  ROLE: 'Role',
  WORKFLOW_DEFINITION: 'Workflow Definition',
  WORKFLOW: 'Workflow', // AP Workflow Setup
  GLOBAL_USERS: 'Global Users',
  DOCUMENT_TYPE: 'Document Type',
  DOCUMENTS: 'Documents',
  EXTERNAL_INTEGRATION: 'External Integration',
  POSITION_MASTER: 'Position Master',
  SKILLS_CERTIFICATIONS: 'Skills / Certifications',
  WORKFORCE_OT_STATE: 'Workforce OT State',
  AUDIT_LOGS: 'Audit Logs',

  // Hidden / commented menus (keep for when restored)
  TREASURY: 'Treasury',
  ANOMALY_DETECTION: 'Anomaly Detection',
  DEBT_COLLECTION: 'Debt Collection',
  ACCOUNTS_PAYABLE: 'Accounts Payable',
  AP_INVOICE: 'AP Invoice',
};

export default FC;
